module.exports = __webpack_public_path__ + "static/media/IMG_5519-min.b7ce20cb.jpg";